import { render, staticRenderFns } from "./dy.vue?vue&type=template&id=2d394abb&"
import script from "./dy.vue?vue&type=script&lang=js&"
export * from "./dy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports